import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { Check } from 'lucide-react';
export function PricingSection() {
  const handleCheckoutClick = () => {
    // Track InitiateCheckout event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <section id="pricing" className="py-24 bg-white" data-id="element-175">
      <div className="max-w-5xl mx-auto px-6" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-rose-500 to-pink-600 p-12 rounded-3xl shadow-2xl text-white" data-id="element-177">
          <div className="text-center mb-8" data-id="element-178">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full mb-6" data-id="element-179">
              <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-180">
                Oferta Especial
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-181">
              A Fórmula do Efeito Boutique™
            </h2>

            <p className="text-xl mb-8 opacity-95" data-id="element-182">
              40 ideias completas + passo a passo + templates + calculadora de
              custos
            </p>

            <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-183">
              <span className="text-3xl line-through opacity-70" data-id="element-184">R$ 97,00</span>
              <span className="text-6xl font-bold" data-id="element-185">R$ 19,90</span>
            </div>

            <p className="text-lg mb-8 opacity-95" data-id="element-186">
              Menos que <span className="font-bold" data-id="element-187">1 lembrancinha pronta</span>{' '}
              para ter <span className="font-bold" data-id="element-188">40 ideias completas</span>
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl mb-8" data-id="element-189">
            <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-190">
              Você economiza:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-191">
              <div className="flex items-center gap-3" data-id="element-192">
                <Check className="w-6 h-6 flex-shrink-0" data-id="element-193" />
                <span className="text-lg" data-id="element-194">
                  R$ 400 a R$ 1.800 (100 convidados)
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-195">
                <Check className="w-6 h-6 flex-shrink-0" data-id="element-196" />
                <span className="text-lg" data-id="element-197">
                  R$ 800 a R$ 3.600 (200 convidados)
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-198">
                <Check className="w-6 h-6 flex-shrink-0" data-id="element-199" />
                <span className="text-lg" data-id="element-200">Horas de pesquisa no Pinterest</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-201">
                <Check className="w-6 h-6 flex-shrink-0" data-id="element-202" />
                <span className="text-lg" data-id="element-203">Ansiedade e insegurança</span>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-204">
            <CTAButton variant="secondary" size="large" onClick={handleCheckoutClick} data-id="element-205">
              Quero Economizar e Impressionar
            </CTAButton>
            <p className="text-sm mt-4 opacity-90" data-id="element-206">
              Acesso imediato • Pagamento 100% seguro • Satisfação garantida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}